module.exports = __webpack_public_path__ + "static/media/customized.bbe491c8.svg";